
export default {
  props: {
    attachments: {
      type: Array,
      default: null
    },
    ratio: {
      type: String,
      default: 'square'
    },
    slidesPerView: {
      type: [Number, Object],
      default() {
        return { xs: 4, md: 6 }
      }
    }
  },
  vessel: {
    carousel: {
      position: 'relative'
    },
    overlay: {
      position: 'absolute',
      width: 'full',
      pinTop: true,
      padding: 'sm',
      pointerEvents: 'none'
    },
    icon: {
      pointerEvents: 'auto',
      color: 'blue',
      padding: 'xs',
      fontSize: '2xl',
      backgroundColor: 'white',
      borderRadius: 'full',
      cursor: 'pointer',
      shadow: true
    }
  },
  methods: {
    onClick(slide, clickAllowed) {
      if (clickAllowed()) {
        this.$lightbox.show('gallery-carousel', slide)
      }
    }
  }
}
